module.exports = __webpack_public_path__ + "img/52.8b2ea8c7.jpg";